

const state = () => ({
    initialized: false,
    sanitized: false,
    nativeDevice: false,
    errors: [],
    allCategories: [],
    allSubCategories: [],
    // allCities: [],
    // initCities: false,
    // initRegions: false,
    // initZones: false,
    allRegions: [],
    allZones: [],
    data: {},
    firedInAppGtmFlag: false,
})

export default state